import { AntSkeleton, Progress, Text } from '@agro-club/agroclub-shared'
import { Card } from 'views/components/Card/Card'
import { StatsType } from './types'
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { stringify } from 'query-string'
import formatNumber from 'modules/utils/numbers/formatNumber'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
`

const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 13px;
`

export const StatsComponent: FC<{ listRequestParams: ListRequestParams }> = ({ listRequestParams }) => {
  const { t } = useTranslation('user')
  const statQs =
    listRequestParams.filter?.product_id && listRequestParams.filter?.region
      ? stringify({
          product_id: listRequestParams.filter.product_id,
          region: listRequestParams.filter.region,
        })
      : undefined
  const [statProgress, statData] = useSingleEntity<StatsType>(
    statQs && `${endpoints.productDataAnalyticsStats()}?${statQs}`,
    false,
  )

  let content: ReactElement | null = null

  if (!statQs) {
    content = (
      <Wrapper>
        <Text color="secondary">{t('chooseRegionAndProduct')}</Text>
      </Wrapper>
    )
  } else {
    const loaded = !!(statProgress == Progress.SUCCESS && statData)
    const skeleton = <AntSkeleton.Button active size="small" style={{ width: 25, borderRadius: 4 }} />
    content = (
      <>
        <StatWrapper style={{ width: '140px', marginRight: '225px' }}>
          <Text color="secondary" typography="bodyMedium">
            {t('productDataLabels.sowed_area')}
          </Text>
          <Text color="secondary" typography="accentMedium">
            {loaded ? formatNumber(statData.sowed_area) : skeleton}
          </Text>
        </StatWrapper>
        <StatWrapper>
          <Text color="secondary" typography="bodyMedium">
            {t('productDataLabels.statCropYield')}
          </Text>
          <Text color="secondary" typography="accentMedium">
            {loaded ? formatNumber(statData.capacity_in_ton) : skeleton}
          </Text>
        </StatWrapper>
      </>
    )
  }
  return (
    <Card.Container style={{ marginBottom: '20px' }}>
      <Wrapper>
        <div style={{ width: '615px' }}>
          <Text color="secondary">{t('regionData')}:</Text>
        </div>
        {content}
      </Wrapper>
    </Card.Container>
  )
}
